export default __webpack_public_path__ + "static/media/seelater-icon.dd3e8c61.svg";